import { useEffect } from "react";

// Merge the "Accessories" group of every selected model into one group.
// Attributes are matched by attributeName, values by valueName, so common
// data appears only once.
const buildAccessoriesGroup = (tabs) => {
    const attrMap = new Map();
    let baseGroup = null;

    tabs.forEach((tab) => {
        (tab.product?.productSpecGroupMaps ?? [])
            .filter((g) => g.groupName === "Accessories")
            .forEach((group) => {
                baseGroup = baseGroup ?? group;

                (group.productSpecMaps ?? []).forEach((spec) => {
                    if (!attrMap.has(spec.attributeName)) {
                        attrMap.set(spec.attributeName, {
                            ...spec,
                            productSpecValueMaps: [],
                        });
                    }
                    const target = attrMap.get(spec.attributeName);

                    (spec.productSpecValueMaps ?? []).forEach((val) => {
                        const exists = target.productSpecValueMaps.some(
                            (x) => x.valueName === val.valueName
                        );
                        if (!exists) target.productSpecValueMaps.push(val);
                    });
                });
            });
    });

    if (!baseGroup) return null;

    const productSpecMaps = [...attrMap.values()]
        .map((spec) => ({
            ...spec,
            productSpecValueMaps: [...spec.productSpecValueMaps].sort(
                (a, b) => a.sequence - b.sequence
            ),
        }))
        .sort((a, b) => a.sequence - b.sequence);

    return { ...baseGroup, productSpecMaps };
};

export const AssemblyConfigure = ({ setProductTab, ProductTab }) => {
    useEffect(() => {
        const tabs = ProductTab?.assemblyTabs ?? [];
        const first = tabs[0];
        if (!first?.product) {
            setProductTab({ ...ProductTab, tab: ProductTab?.redirectTab });
            return;
        }

        const allSelectedConfiguration =
            ProductTab?.allSelectedConfiguration ?? ProductTab?.selectedConfiguration ?? [];

        const wantsAccessories = allSelectedConfiguration.some(
            (c) =>
                c.attributeName === "Accessories" &&
                String(c.valueName ?? "").toLowerCase() === "yes"
        );

        const accessoriesGroup = wantsAccessories ? buildAccessoriesGroup(tabs) : null;

        const finalTabs = accessoriesGroup
            ? [
                ...tabs,
                {
                    key: "accessories",
                    label: "Accessories",
                    isAccessories: true,
                    title: ProductTab?.id?.productName || "FAI",
                    imageUrl: ProductTab?.id?.imageUrl,
                    product: {
                        ...first.product,
                        productSpecGroupMaps: [accessoriesGroup],
                    },
                    summary: allSelectedConfiguration.map((c) => ({
                        label: c.attributeName,
                        value: c.valueName,
                    })),
                },
            ]
            : tabs;

        const attrNames = new Set(
            (first.product.productSpecGroupMaps ?? []).flatMap((group) =>
                (group.productSpecMaps ?? []).map((spec) => spec.attributeName)
            )
        );

        setProductTab({
            tab: "ProductQuotation",
            id: first.product,
            selectedConfiguration: allSelectedConfiguration.filter((c) =>
                attrNames.has(c.attributeName)
            ),
            allSelectedConfiguration,
            assemblyTabs: finalTabs,
            assemblyProduct: ProductTab?.assemblyProduct ?? ProductTab?.id,
            activeAssemblyKey: first.key,
            subCategoryId: ProductTab?.subCategoryId,
            productSubCategoryId: ProductTab?.productSubCategoryId,
            title: ProductTab?.title,
            redirectTab: ProductTab?.redirectTab,
            assemblySelection: ProductTab?.assemblySelection,
        });
    }, []);

    return null;
};